<template>
  <footer class="footer">
    <div class="footer-content">
      <FeedBack />
      <button @click="openWeChatModal" class="footer-action-button footer-action-button-ghost">
        加入微信群
      </button>
    </div>

    <!-- WeChat Group QR Code Modal -->
    <div
      v-if="showWeChatModal"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center"
    >
      <div class="bg-white p-6 rounded-lg w-96 shadow-lg relative">
        <h3 class="text-2xl mb-4 text-center" style="color: black">
          {{ $t('footer.contact.wechatModal.title') }}
        </h3>
        <img
          src="/static/wechat.jpg"
          alt="WeChat Group QR Code"
          class="rounded-lg max-w-full h-auto"
        />
        <button
          @click="closeWeChatModal"
          class="absolute top-2 right-4 text-gray-600 hover:text-gray-800"
        >
          ×
        </button>
      </div>
    </div>
  </footer>
</template>

<script>
import FeedBack from './FeedBack.vue';

export default {
  name: "AppFooter",
  components: { FeedBack },
  data() {
    return {
      showWeChatModal: false,
    };
  },
  methods: {
    openWeChatModal() {
      this.showWeChatModal = true;
    },
    closeWeChatModal() {
      this.showWeChatModal = false;
    },
  },
};
</script>

<style scoped>
.footer {
  background: #0f172a;
  color: #f8fafc;
  padding: 0.45rem 0.75rem 0.55rem;
}

.footer-content {
  max-width: 720px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.wechat-button {
  background: #10b981;
  color: #ffffff;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  transition: transform 0.2s ease, background-color 0.2s ease;
  font-weight: 600;
}

.footer-action-button {
  appearance: none;
  border: 1px solid rgba(148, 163, 184, 0.24);
  background: rgba(15, 23, 42, 0.72);
  color: #f8fafc;
  padding: 0.5rem 0.85rem;
  border-radius: 999px;
  cursor: pointer;
  font-size: 0.88rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 1;
  transition: transform 0.18s ease, background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
}

.footer-action-button:hover {
  transform: translateY(-1px);
  background: rgba(30, 41, 59, 0.92);
  border-color: rgba(148, 163, 184, 0.38);
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.16);
}

.footer-action-button:focus-visible {
  outline: 2px solid rgba(96, 165, 250, 0.9);
  outline-offset: 2px;
}

.footer-action-button-ghost {
  background: rgba(30, 41, 59, 0.5);
}

.footer-action-button-ghost:hover {
  background: rgba(30, 41, 59, 0.8);
}

button.absolute {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

button.absolute:focus {
  outline: none;
}
</style>
